"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginBase_1 = require("auto-widget-framework/src/Plugin/PluginBase");
/**
 * Form handler base plugin.
 */
class FormExtensionPluginBase extends PluginBase_1.default {
}
exports.default = FormExtensionPluginBase;
